import React, { useContext, useState } from 'react';
import { ContextProps } from '../types/ContextProps';
import { PbiReportPage } from 'src/types/ViewModel/PbiReportPage';

type PbiReportPagesContextType = {
    reportPages: PbiReportPage[] | null;
    setReportPages: (reportPages: PbiReportPage[] | null) => void;
    selectedReport: string | null;
    setSelectedReport: (selectedReport: string | null) => void;
};

export const PbiReportPagesContext = React.createContext<PbiReportPagesContextType>(undefined!);

export const PbiReportsContextProvider = ({ children }: ContextProps) => {
    const [reportPages, setReportPages] = useState<PbiReportPage[] | null>(null);
    const [selectedReport, setSelectedReport] = useState<string | null>(null);

    return (
        <PbiReportPagesContext.Provider
            value={{
                reportPages,
                setReportPages,
                selectedReport,
                setSelectedReport,
            }}
        >
            {children}
        </PbiReportPagesContext.Provider>
    );
};

export const usePbiReportPagesStore = () => useContext(PbiReportPagesContext);
